import { compilePath } from '../../utils/paths'
import { pathByApplyStatus, LOGIN_PATH, REGISTER_PATH } from './constants'

export const getNoLoggedPath = hasUser => hasUser ? LOGIN_PATH : REGISTER_PATH

export const getApplyToStepPath = (step, apply) => compilePath(
  pathByApplyStatus[step],
  { id: apply.id }
)
export const getApplyStepPath = apply => compilePath(
  pathByApplyStatus[apply.status],
  { id: apply.id }
)
